<footer
  class="footer"
  [class.hide-footer]="shouldHideFooter()"
  aria-label="footer"
  data-analytics-nav="footer">
  <div class="footer-container">
    <div class="branding-and-links">
      <div class="brand">
        <img
          class="footer-logo"
          [src]="footerLogoImageUrl"
          [alt]="footerLogoAltText" />
      </div>

      <div class="links">
        <a class="link-item focus-link" [href]="faqsUrl()">{{
          'app.faq' | translate
        }}</a>
        <a class="link-item focus-link" [href]="tncsUrl">{{
          'app.terms_and_conditions' | translate
        }}</a>
        <a class="link-item focus-link" [href]="privacyPolicyUrl">{{
          'app.privacy_policy' | translate
        }}</a>
        <a class="link-item focus-link" [href]="contactUsUrl()">{{
          'app.contact_us' | translate
        }}</a>
      </div>
    </div>
    <div class="administration-info">
      <p class="administration-info-text">
        {{
          'wl.westpac.footer_administrative_text'
            | translate: adminInfoTextParams()
        }}
      </p>
    </div>
  </div>
</footer>
